import { useState } from "react";

// pricing content
const PricingSwitcher = ({pricingSwitcherLAbel, pricingSwitcherContent}) => {
  const [activeSwitcherLabel, setActiveSwitcherLabel] = useState(pricingSwitcherLAbel[0].label);

  const handleSwitcherChange = (newSwitcherLabel) => {
    setActiveSwitcherLabel(newSwitcherLabel);
  };

    return(
      <>
        <div className="row">
            <div className="col-12">
                <div className="pricing-switcher">
                {Array.isArray(pricingSwitcherLAbel) && pricingSwitcherLAbel.map((pricingSwitcherLAbelItem) => (
                    <a key={pricingSwitcherLAbelItem.label}
                    className={`btn ${activeSwitcherLabel === pricingSwitcherLAbelItem.label ? "active" : ""}`} 
                    id={pricingSwitcherLAbelItem.label} 
                    onClick={() => handleSwitcherChange(pricingSwitcherLAbelItem.label)}
                    >{pricingSwitcherLAbelItem.label}</a>
                ))}
                </div>
            </div>
        </div>



        <div className={`pricing-container ${activeSwitcherLabel} `}>
            <div className="row">
            {Array.isArray(pricingSwitcherContent) && pricingSwitcherContent.slice(0, 3).map((pricingSwitcherContentItem) => (
             
              <div className="col-12 col-lg-4 price-table"  key={pricingSwitcherContentItem._id}>
                
                <div className={`pricing-panel ${pricingSwitcherContentItem.dataMonthly.switcher} 
                ${activeSwitcherLabel === 'Monthly' ? 'visible' : 'hidden'}`}>
                 
                  <div className="pricing-head">
                    <h6 className="pricing-name">{pricingSwitcherContentItem.dataMonthly.headName}</h6>
                    <div className="pricing-type">
                      <p className="price">${pricingSwitcherContentItem.dataMonthly.headPrice}</p>
                      <p className="per">{pricingSwitcherContentItem.dataMonthly.headBasis}</p>
                    </div>
                  </div>
                 
                  <div className="pricing-body">
                    <ul className="pricing-list list-unstyled">
                    {Array.isArray(pricingSwitcherContentItem.dataMonthly.featureLIst) && 
                    pricingSwitcherContentItem.dataMonthly.featureLIst.map((pricingList, index) => (
                      <li key={index}>{pricingList.prices_monthly_plan_feature_title}</li>
                    ))}
                      
                    </ul><a className="btn btn--bordered btn--primary" href={pricingSwitcherContentItem.dataMonthly.buttonLink} 
                    target="_blank">{pricingSwitcherContentItem.dataMonthly.buttonText}</a>
                  </div>
                </div>

                <div className={`pricing-panel ${pricingSwitcherContentItem.dataYearly.switcher} 
                ${activeSwitcherLabel === 'Yearly' ? 'visible' : 'hidden'}`}>
                 
                  <div className="pricing-head">
                    <h6 className="pricing-name">{pricingSwitcherContentItem.dataYearly.headName}</h6>
                    <div className="pricing-type">
                      <p className="price">${pricingSwitcherContentItem.dataYearly.headPrice}</p>
                      <p className="per">{pricingSwitcherContentItem.dataYearly.headBasis}</p>
                    </div>
                  </div>
                 
                  <div className="pricing-body">
                    <ul className="pricing-list list-unstyled">
                    {Array.isArray(pricingSwitcherContentItem.dataYearly.featureLIst) &&
                    pricingSwitcherContentItem.dataYearly.featureLIst.map((pricingList, index) => (
                      <li key={index}>{pricingList.prices_yearly_plan_feature_title}</li>
                    ))}
                      
                    </ul><a className="btn btn--bordered btn--primary" href={pricingSwitcherContentItem.dataYearly.buttonLink}
                    target="_blank">{pricingSwitcherContentItem.dataYearly.buttonText}</a>
                  </div>
                </div>

              </div>
             
            ))}
              
            </div>
          </div>

      </>
    );
}
  
export default PricingSwitcher;
